import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, FormControl, FormGroup, Well, Panel } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withFormik } from 'formik';
import Cards from 'react-credit-cards';
import $ from 'jquery';
import Button from './Button';
import AutoComplete from './AutoComplete';
import TextInput from './TextInput';
import ConfirmDialog from './ConfirmDialog';
import LoadingProgressBar from './LoadingProgressBar';
import ServerError from './ServerError';
import InvoiceItems from './InvoiceItems';
import { caseSetServerError,
         caseLawPayPayPublicAction } from '../../actions/caseActions';

import { userLawPayListAccountsAction,
         userLawPayAccountSetAction, 
         userLawPayDeleteAction} from '../../actions/userActions';

import { normalizeExpiry } from '../../helpers/normalizers';
import { oauth2ClientPopup } from '../../helpers/utils';
import { isEmptyObject, validateRequired, validateText, validateEmail, validateExpiry } from '../../validators/formValidators';
import { getCountryCode, getStatesLabel, getSupportedCountryCodesOptions, getStatesOptions } from '../../helpers/internationalization';
import { requiredFormFieldColor } from '../../helpers/colors';


class LawPay extends PureComponent {
    constructor(props) {
        super(props);
        this.onScriptLoaded = this.onScriptLoaded.bind(this);
        this.loadScript = this.loadScript.bind(this);
        this.onError = this.onError.bind(this);
        this.renderSignInButton = this.renderSignInButton.bind(this);
        this.renderForm = this.renderForm.bind(this);
        this.renderPayButton = this.renderPayButton.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.signIn = this.signIn.bind(this);
        this.cancel = this.cancel.bind(this);
        this.pay = this.pay.bind(this);
        this.onAccountsChange = this.onAccountsChange.bind(this);
        this.accountsDialogCofirm = this.accountsDialogCofirm.bind(this);
        this.affiniPayInit = this.affiniPayInit.bind(this);
        this.hostedFieldsCallback = this.hostedFieldsCallback.bind(this);
        this.authOrPay = this.authOrPay.bind(this);
        this.validateForm = this.validateForm.bind(this);
        this.defaultState = {
            processing: false,
            payingEnabled: false,
            payingIsReady: false,
            popup: undefined,
            accountsDialogOpen: false,
            accounts: [],
            selectedAccount: undefined,
            emailSet: false,
            scriptLoading: false,
            scriptLoaded: false,
            scriptDidError: false,
            focus: undefined,
            cardNumberField: undefined,
            cardCvvField: undefined,
        };
        this.state = this.defaultState;
    }

    componentDidMount() {
        if (this.props.account) {
            this.loadScript();
            this.affiniPayInit(this.props.account);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.account) {
            this.loadScript();
            this.affiniPayInit(nextProps.account);
        }
    }

    componentWillUnmount() {
        if (this.loadPromise) {
            this.loadPromise.cancel();
        }
        $('iframe').remove();
    }

    onScriptLoaded() {
        this.affiniPayInit(this.props.account);
    }

    onError(error) {
        if (this.props.onError) {
            this.props.onError(error);
        }
    }

    onAccountsChange(evt) {
        let accounts = [...this.state.accounts];
        let selectedAccount;
        for (let i = 0; i < accounts.length; i++) {
            if (!!evt.target[i].selected) {
                selectedAccount = accounts[i];
                break;
            }
        }

        this.setState({selectedAccount});
    }

    accountsDialogCofirm(evt) {
        evt.preventDefault();
        this.props.dispatch(userLawPayAccountSetAction(this.state.selectedAccount))
            .then(result => {
                if (!result.data) {
                    this.props.dispatch(caseSetServerError('Cannot set LawPay merchant account.'));
                    return;
                }

                // Selected account will get updated in current user automatically.
                this.setState({accountsDialogOpen: false});

            }).catch(error => {
                this.setState({accountsDialogOpen: false});
                this.props.dispatch(caseSetServerError(error));
            });
    }

    authOrPay(cardToken = undefined, caseId = undefined, amount = undefined, publicHash = undefined, description = undefined) {
        this.setState({processing: true});
        let cleanup = () => {
            this.setState({
                processing: false,
                popup: undefined
            });
        };

        let onPopup = (popup) => {
            this.setState({popup});
        };

        let selectAccount = () => {
            this.props.dispatch(userLawPayListAccountsAction())
                .then((result) => {
                    cleanup();
                    if (!result.data) {
                        onError('Cannot retrieve LawPay merchant accounts.');
                        return;
                    }

                    let accounts = result.data.sort((a, b) => {
                        if (!a.trust_account) {
                            return -1;
                        }

                        if (!b.trust_account) {
                            return 1;
                        }

                        return 0;
                    });

                    let selectedAccount;
                    if (accounts.length > 0) {
                        selectedAccount = accounts[0];
                    }

                    this.setState({accounts, selectedAccount});
                    this.setState({accountsDialogOpen: true});

                }).catch ((error) => {
                    cleanup();
                    onError(error);
                });
        };

        let onError = (error) => {
            switch (error) {
            case 'EMPTY_RESPONSE':
                this.props.onError('Signing to LawPay failed.');
                break;

            case 'AUTH_FAILED':
                break;

            case 'NO_ACCOUNT_SELECTED':
                selectAccount();
                break;

            default:
                this.props.onError(error);
                break;

            }

            cleanup();
        };

        let onSuccess = () => {
            if (!cardToken) {
                selectAccount();

            } else {
                cleanup();
                if (this.props.onSuccess) {
                    this.props.onSuccess();
                }
            }
        }

        oauth2ClientPopup(
            this.props.dispatch(caseLawPayPayPublicAction(cardToken, caseId, amount, publicHash, description, this.props.account)),
            onPopup,
            onSuccess,
            onError,
            'Successfully authenticated with LawPay.',
            'Authentication with LawPay failed.',
            () => {
                if (!this.props.publicHash) {
                    return true;
                }

                cleanup();
                this.props.dispatch(caseSetServerError("Payment has been disabled."));
                return false;
            }
        );
    }

    async pay(evt) {
        evt.preventDefault();
        const errors = this.validateForm();
        if (!isEmptyObject(errors)) {
            for (let field in errors) {
                this.props.setFieldTouched(field, true, false);
                this.props.setFieldError(field, errors[field]);
            }

            return;
        }
        if (!this.hostedFields.getState()) {
            this.props.dispatch(caseSetServerError('Payment request error!'));
            return;
        }

        this.setState({processing: false});
        if (!this.props.account) {
            this.setState({accountsDialogOpen: true});
            return;
        }

        if (!this.props.amount) {
            this.props.dispatch(caseSetServerError('Please specify the charged amount.'));
            return;
        }

        this.setState({processing: true});
        const values = {...this.props.values};
        delete values['number'];
        delete values['cvv'];
        values['exp_year'] = '20' + values['expiry'].substr(3);
        values['exp_month'] = values['expiry'].substr(0, 2);
        try {
            const result = await this.hostedFields.getPaymentToken(values);
            this.authOrPay(result, this.props.caseId, this.props.amount, this.props.publicHash, this.props.description);
        } catch(error) {
            this.setState({processing: false});
            this.onError(error);
        }
    }

    signIn(evt) {
        this.setState({processing: true});
        this.authOrPay();
    }

    loadScript() {
        if (this.state.scriptLoaded || this.state.scriptLoading) {
            return;
        }

        if ($('#AffiniPayScript').length) {
            this.setState({scriptLoaded: true});
            this.setState({scriptLoading: false});
            this.onScriptLoaded();
            return;
        }

        this.setState({scriptLoading: true});
        const script = document.createElement('script');
        if (typeof this.props.onScriptTagCreated === 'function') {
              this.props.onScriptTagCreated(script);
        }

        script.id = 'AffiniPayScript';
        script.src = 'https://cdn.affinipay.com/hostedfields/1.0.0/fieldGen_1.0.0.js';
        script.async = 1;
        this.loadPromise = (() => {
            let canceled = false;
            const promise = new Promise((resolve, reject) => {
                script.onload = () => {
                    this.setState({scriptLoaded: true});
                    this.setState({scriptLoading: false});
                    resolve();
                    this.onScriptLoaded();
                };

                script.onerror = (event) => {
                    this.setState({scriptDidError: true});
                    this.setState({scriptLoading: false});
                    reject(event);
                    this.onError('LawPay service is not responding.');
                };
            });

            const wrappedPromise = new Promise((accept, cancel) => {
                promise.then(() => canceled ? cancel({ isCanceled: true }) : accept()); // eslint-disable-line no-confusing-arrow
                promise.catch(error => canceled ? cancel({ isCanceled: true }) : cancel(error)); // eslint-disable-line no-confusing-arrow
            });

            return {
                promise: wrappedPromise,
                cancel() { canceled = true; }
            };
        })();

        this.loadPromise.promise
          .then(this.onScriptLoaded)
          .catch(this.onError);

        document.body.appendChild(script);
    }

    hostedFieldsCallback(state) {
        const target = state.target;
        const field = target.selector.substr(1); // avoid '#' id selector
        if (!target.error) {
            target.error = undefined;
        }

        if (target.focus) {
            this.setState({ focus: field });
        }

        if (target.type === 'credit_card_number') {
            this.setState({ cardNumberField: target });
        } if (target.type === 'cvv') {
            this.setState({ cardCvvField: target });
        }

        this.setState({ payingIsReady: state.isReady });
    }

    handleFocus(e) {
        const name = e.target.name || e.target.id;
        this.setState({ focus: name });
        this.props.setFieldTouched(name, true, false);
    }

    handleChange(e) {
        this.props.setFieldValue(e.target.name, e.target.value, false);
        this.validateForm({field: e.target.name, value: e.target.value});
    }

    handleBlur(e) {
        // name is not an element for AutoComplete, only id is
        const name = e.target.name || e.target.id;
        this.validateForm({field: name});
    }

    affiniPayInit(account) {
        const cardEl = $("#number");
        if (this.initialized && cardEl.length === 0) {
            this.initialized = false;
        }
        if (!this.initialized &&
            !isEmptyObject(account) &&
            typeof(window) !== 'undefined' &&
            typeof(window.AffiniPay) !== 'undefined' &&
            cardEl.length &&
            cardEl.is(":visible")
        ) {
            this.initialized = true;
            // Mimicking Bootstrap 3 / Paper theme
            const css = {
                'background-color': 'rgba(0, 0, 0, 0)',
                'box-shadow': 'rgb(221, 221, 221) 0px -1px 0px 0px inset',
                'box-sizing': 'border-box',
                'color': 'rgb(102, 102, 102)',
                'cursor': 'text',
                'display': 'block',
                'font-family': 'Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif',
                'font-size': '16px',
                'font-stretch': '100%',
                'font-weight': '400',
                'height': '37px',
                'letter-spacing': '0.1px',
                'line-height': '29.536px',
                'margin-bottom': '0px',
                'margin-left': '0px',
                'margin-right': '0px',
                'margin-top': '0px',
                'padding-bottom': '0px',
                'padding-left': '0px',
                'padding-right': '0px',
                'padding-top': '0px',
                'text-align': 'start',
                'text-indent': '0px',
                'text-rendering': 'auto',
                'text-shadow': 'none',
                'text-size-adjust': '100%',
                'text-transform': 'none',
                'transition-delay': '0s, 0s',
                'transition-duration': '0.15s, 0.15s',
                'transition-property': 'border-color, box-shadow',
                ':focus': {
                    'box-shadow': 'rgb(33, 150, 243) 0px -2px 0px 0px inset'
                },
                ':invalid': {
                    color: requiredFormFieldColor
                },
                ':required': {
                    color: requiredFormFieldColor
                }
            };

            const hostedFieldsConfiguration = {
                publicKey: account.public_key,
                fields: [
                    {
                        selector: '#number',
                        input: {
                            type: 'credit_card_number',
                            css
                        }
                    },
                    {
                        selector: '#cvv',
                        input: {
                            type: 'cvv',
                            css
                        }
                    },
                ]
            };

            this.hostedFields = window.AffiniPay.HostedFields.initializeFields(
                hostedFieldsConfiguration, this.hostedFieldsCallback);

            this.setState({ payingEnabled: true });
        }

        if (this.props.email && !this.state.emailSet) {
            this.setState({emailSet: true})
        }
    }

    cancel() {
        this.setState({ processing: true });
        this.props.dispatch(userLawPayDeleteAction())
            .then(() => {
                this.setState({ processing: false });

            }).catch((error) => {
                this.props.dispatch(caseSetServerError(error));
                this.setState({ processing: false });
            });
    }

    renderSignInButton() {
        if (this.props.loggedIn && this.props.loggedIn.owner_id !== 0 && isEmptyObject(this.props.account)) {
            return (
                <Row>
                    <Col xs={8} md={9}>
                        <Well><img src="/img/lawpay_logo.png" style={{ height: 25, marginRight: 10 }}/> integration missing to activate e-payments.</Well>
                    </Col>
                </Row>
            );
        }

        if (!isEmptyObject(this.props.account)) {
            return (
                <Button label="Disconnect"
                        style={{width: 200}}
                        img="/img/lawpay_logo.png"
                        imgStyle={{height: 25}}
                        loading={this.state.processing}
                        onClick={this.cancel}
                        disabled={this.state.processing || this.props.disabled}
                        loadingLabel=""
                        tooltip="Disconnect LawPay account integration."
                />
            );
        }

        let integrateButton = (
            <React.Fragment>
                <Button style={{width: 120}}
                        img="/img/lawpay_logo.png"
                        imgStyle={{height: 25}}
                        loading={this.state.processing}
                        loadingLabel=""
                        onClick={this.signIn}
                        disabled={this.state.processing || this.props.disabled}
                        tooltip="Integrate payment with your LawPay account"/>
                <ConfirmDialog title='LawPay Settings'
                               text=''
                               cancel={() => {this.setState({accountsDialogOpen: false})}}
                               confirm={this.accountsDialogCofirm}
                               open={this.state.accountsDialogOpen}>

                    Choose the account where you want the fees to be send to.
                    <FormGroup controlId="accounts">
                        <FormControl componentClass="select"
                                     disabled={this.state.accounts.length === 0}
                                     loading={this.state.accounts.length === 0}
                                     options={this.state.accounts}
                                     onChange={this.onAccountsChange}>

                            {this.state.accounts.map((account, index) => {
                                let key = `${account.id}`;
                                let trustAccount = account.trust_account ? 'Trust account' : 'Operational account';
                                let label = `${trustAccount} - ${account.name}`;
                                return (<option key={key}
                                                value={key}>{label}
                                        </option>);
                            })}
                        </FormControl>
                    </FormGroup>
                </ConfirmDialog>
            </React.Fragment>
        );

        if (this.props.renderIntegrateButtonOnly) {
            return integrateButton;
        }

        return (
            <Row>
                <Col xs={8} md={9}>
                    {integrateButton}
                </Col>
            </Row>
        );
    }

    renderPayButton() {
        const disabled = this.state.processing || !this.state.payingEnabled || !this.state.payingIsReady || this.props.disabled || !isEmptyObject(this.props.errors);
        return (
            <Button style={{minWidth: 230, marginBottom: 5, marginRight: 15, float: 'right'}}
                    id="pay"
                    label={`Pay ($${(this.props.amount / 100.0).toFixed(2)})`}
                    img="/img/lawpay_logo.png"
                    imgStyle={{ height: 25 }}
                    loading={this.state.processing}
                    onClick={this.pay}
                    disabled={disabled}
                    loadingLabel=""
            />
        )
    }

    validateForm(field = undefined) {
        let errors = {...this.props.errors};
        let values = {...this.props.values};
        let requiredFields = [
            'name',
            'address1',
            'city',
            'state',
            'postal_code',
            'country',
        ];

        if (field) {
            requiredFields = requiredFields.filter(f => f === field.field);
            values[field.field] = field.value || values[field.field];
        }
    
        requiredFields.forEach(f => {
            const value = values[f];
            let error = validateRequired(value, f);
            error = error || validateText(value, f);
            if (error) {
                this.props.setFieldError(f, error[f], false);
            }
            errors = { ...errors, ...error };
        });

        if (!field || field.field === 'email') {   
            let error = validateRequired(values['email'], 'email');
            if (isEmptyObject(error)) {
                error = validateEmail(values['email'], 'email');
            }
            if (error) {
                this.props.setFieldError('email', error['email'], false);
            }
            errors = { ...errors, ...error };
        }

        if (!field || field.field === 'expiry') {   
            let error = validateRequired(values['expiry'], 'expiry');
            if (isEmptyObject(error)) {
                error = validateExpiry(values['expiry'], 'expiry');
            }
            if (error) {
                this.props.setFieldError('expiry', error['expiry'], false);
            }
            errors = { ...errors, ...error };
        }

        if ((!field || field.field === 'number') && this.state.cardNumberField && this.state.cardNumberField.error) {
            errors['number'] = this.state.cardNumberField.error;
        }

        if ((!field || field.field === 'cvv') && this.state.cardCvvField && this.state.cardCvvField.error) {
            errors['cvv'] = this.state.cardCvvField.error;
        }

        return errors;
    }

    renderForm(paymentButton = true) {
        const disabled = this.state.processing || !this.state.payingEnabled || this.props.disabled;
        const {
            setFieldValue,
            values,
            touched,
            errors
        } = this.props;

        const handleBlur = this.handleBlur;
        const handleChange = this.handleChange;
        return (
            <Row style={{ overflow: 'hidden' }}>
            {!isEmptyObject(this.props.invoiceItems) && this.props.invoiceItems.items && this.props.invoiceItems.items.length > 0 && !this.props.showAsDialog && (
                <Col xs={12}>
                <Panel header="Invoice Items">
                    <InvoiceItems invoiceItems={this.props.invoiceItems} />
                </Panel>
                </Col>
            )}
            {this.props.description && !this.props.showAsDialog && (
                <Col xs={12}>
                <Panel header="Description">
                    <Well>{this.props.description.split('\n').map(line => <span>{line}<br /></span>)}</Well>
                </Panel>
                </Col>
            )}
            {this.props.publicHash && <ServerError error={this.props.serverError} style="popup" close={() => this.props.dispatch(caseSetServerError(undefined))} />}
            <form id='CardForm'>
            <Col xs={12} md={6}>
            <Panel header='Credit / Debit Card Information' bsStyle='default'>
                <Row style={{marginTop: -11}}>
                <Col xs={12}>
                    <Cards
                        cvc={(this.state.cardCvvField && this.state.cardCvvField.token && '***') || ''}
                        expiry={values['expiry'] || ''}
                        focused={this.state.focus === 'cvv' ? 'cvc' : this.state.focus || ''}
                        name={values['name'] || ''}
                        number={(this.state.cardNumberField && this.state.cardNumberField.token && '**** **** **** ****') || ''}
                        issuer={(this.state.cardNumberField && this.state.cardNumberField.card) || ''}
                        preview
                    />
                </Col>
                </Row>
                <div style={{ marginLeft: 15, marginRight: 15, marginTop: 6 }} className='form-group'>
                    <label for="number" style={{ color: this.state.cardNumberField && this.state.cardNumberField['error'] && 'rgb(229, 28, 35)' }}>Card Number</label>
                    <div id="number"
                         ref={el => {
                             if (!el) {
                                 return;
                             }
                             this.affiniPayInit(this.props.account);
                         }}
                    />
                    {!this.state.payingEnabled && <LoadingProgressBar loading />}
                    <p className="help-block" style={{marginBottom: '0px', color : 'rgb(229, 28, 35)'}}>{this.state.cardNumberField && this.state.cardNumberField['error']}</p>
                </div>
                <Row>
                <Col xs={12}>
                    <TextInput field={{
                                    name: 'name',
                                    onChange: handleChange,
                                    onBlur: handleBlur,
                                    error: errors['name'],
                                    touched: touched['name'],
                                    value: values['name'],
                            }}
                            onFocus={this.handleFocus}
                            label="Full Name"
                            disabled={disabled}
                    />
                </Col>
                </Row>
                <Row>
                <Col xs={12}>
                    <TextInput field={{
                                    name: 'expiry',
                                    onBlur: handleBlur,
                                    error: errors['expiry'],
                                    touched: touched['expiry'],
                                    value: values['expiry'],
                               }}
                               onFocus={this.handleFocus}
                               label="Expiration Date (MM/YY)"
                               disabled={disabled}
                               onChange={evt => {
                                   const value = normalizeExpiry(evt.target.value, values['expiry']);
                                   this.props.setFieldValue('expiry', value, false);
                                   this.validateForm({field: 'expiry', value});
                               }}
                    />
                </Col>
                </Row>
                <div style={{ marginLeft: 15, marginRight: 15 }} className='form-group'>
                    <label for="cvv" style={{ color: this.state.cardCvvField && this.state.cardCvvField['error'] && 'rgb(229, 28, 35)' }}>CVV / CVC Code</label>
                    <div id="cvv" />
                    {!this.state.payingEnabled && <LoadingProgressBar loading />}
                    <p className="help-block" style={{marginBottom: '0px', color : 'rgb(229, 28, 35)'}}>{this.state.cardCvvField && this.state.cardCvvField['error']}</p>
                </div>
            </Panel>
            </Col>
            <Col xs={12} md={6}>
            <Panel header='Additional Information' bsStyle='default'>
                <Row>
                <Col xs={12}>
                    <TextInput field={{
                                    name: 'email',
                                    onChange: handleChange,
                                    onBlur: handleBlur,
                                    error: errors['email'],
                                    touched: touched['email'],
                                    value: values['email'],
                               }}
                               onFocus={this.handleFocus}
                               label="Email"
                               disabled={disabled}
                    />
                </Col>
                </Row>
                <Row>
                <Col xs={12}>
                    <TextInput field={{
                                    name: 'address1',
                                    onChange: handleChange,
                                    onBlur: handleBlur,
                                    error: errors['address1'],
                                    touched: touched['address1'],
                                    value: values['address1'],
                               }}
                               onFocus={this.handleFocus}
                               label="Address"
                               disabled={disabled}
                    />
                </Col>
                <Col xs={12} style={{ marginTop: -15 }}>
                    <TextInput field={{
                                        name: 'address2',
                                        onChange: handleChange,
                                        onBlur: handleBlur,
                                        error: errors['address2'],
                                        touched: touched['address2'],
                                        value: values['address2'],
                               }}
                               onFocus={this.handleFocus}
                               label=""
                               disabled={disabled}
                    />
                </Col>
                </Row>
                <Row>
                <Col xs={12}>
                    <TextInput field={{
                                    name: 'city',
                                    onChange: handleChange,
                                    onBlur: handleBlur,
                                    error: errors['city'],
                                    touched: touched['city'],
                                    value: values['city'],
                               }}
                               onFocus={this.handleFocus}
                               label="City"
                               disabled={disabled}
                    />
                </Col>
                </Row>
                <Row>
                <Col xs={12}>
                    <AutoComplete field={{
                                        name: 'state',
                                        onChange: (value) => { setFieldValue('state', value, false); this.validateForm({field: 'state', value}); },
                                        onBlur: handleBlur,
                                        error: errors['state'],
                                        touched: touched['state'],
                                        value: values['state'],
                                    }}
                                    onFocus={() => this.handleFocus({target: {name: 'state'}})}
                                    label={getStatesLabel(this.props.country)}
                                    disabled={disabled}
                                    options={getStatesOptions(this.props.country)}
                                    allowNew={false}
                    />
                </Col>
                </Row>
                <Row>
                <Col xs={12}>
                    <TextInput field={{
                                    name: 'postal_code',
                                    onChange: handleChange,
                                    onBlur: handleBlur,
                                    error: errors['postal_code'],
                                    touched: touched['postal_code'],
                                    value: values['postal_code'],
                               }}
                               onFocus={this.handleFocus}
                               label="Postal Code / ZIP"
                               disabled={disabled}
                    />
                </Col>
                </Row>
                <Row>
                <Col xs={12}>
                    <AutoComplete field={{
                                    name: 'country',
                                    onChange: (value) => setFieldValue('country', value),
                                    onBlur: handleBlur,
                                    error: errors['country'],
                                    touched: touched['country'],
                                    value: values['country'],
                               }}
                               onFocus={this.handleFocus}
                               label="Country"
                               disabled={disabled}
                               options={getSupportedCountryCodesOptions()}
                               allowNew={false}
                               isClearable={false}
                    />
                </Col>
                </Row>
                </Panel>
            </Col>
            </form>
            <Row>
            <Col xs={12} >
            {paymentButton && this.renderPayButton()}
            </Col>
            </Row>
            </Row>
        );
    }

    render() {
        if (!this.props.showAsDialog && (this.props.renderIntegrateButtonOnly || isEmptyObject(this.props.account))) {
            return this.renderSignInButton();
        }

        let result = this.renderForm(!this.props.showAsDialog);
        if (this.props.showAsDialog) {
            result = (
                <ConfirmDialog title="Take Payment Manually"
                               cancel={(evt) => {
                                   $('iframe').remove();
                                   if (this.props.dialogCancel) this.props.dialogCancel(evt);
                               }}
                               open={this.props.dialogOpen}
                               size="large"
                               confirmButton={isEmptyObject(this.props.account) ? this.renderSignInButton() : this.renderPayButton()}
                >
                <Row>
                <Col xs={12}>
                {result}
                </Col>
                </Row>
                </ConfirmDialog>
            );
        }

        return result;
    }
}

LawPay.propTypes = {
    account: PropTypes.object,
    loggedIn: PropTypes.object,
    disabled: PropTypes.bool,
    onError: PropTypes.func.isRequired,
    onSuccess: PropTypes.func,

    // Runs when the script tag is created, but before it is added to the DOM
    onScriptTagCreated: PropTypes.func,
    amount: PropTypes.number,
    caseId: PropTypes.number,
    email: PropTypes.string,
    description: PropTypes.string,
    publicHash: PropTypes.string,
    renderIntegrateButtonOnly: PropTypes.bool,
    country: PropTypes.string.isRequired,
};

const mapStateToProps = (state, ownProps) => {
    let initialValues = { 'country': getCountryCode(ownProps.country) };
    return {
        initialValues,
        serverError: state.cases._serverError,
    };
};

const formikWrapper = {
    mapPropsToValues: props => props.initialValues,
    enableReinitialize: true,
};

export default connect(mapStateToProps)(withFormik(formikWrapper)(LawPay));
